import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismTable } from '@mylighthouse/prism-ember';
import HotelStrategyTablesCellsTdStrategyBaserate from 'lumen/components/hotel/strategy/tables/cells/td-strategy-baserate';
import HotelStrategyTablesCellsTdStrategyHotel from 'lumen/components/hotel/strategy/tables/cells/td-strategy-hotel';
import HotelStrategyTablesCellsThStrategyDetail from 'lumen/components/hotel/strategy/tables/cells/th-strategy-detail';
import {
  COLUMN_CONFIG,
  COLUMN_PROPERTIES,
  COLUMN_WIDTH,
  SUBTYPE_DELIMITER,
} from 'lumen/utils/constants/rate-strategy-constants';

interface HotelStrategyTablesTableDetailLeadtimeSignature {
  Args: {
    initialSorts: unknown;
    onTableSort: unknown;
    sortFunction: unknown;
    subtypes: unknown;
  };
}

export default class HotelStrategyTablesTableDetailLeadtime extends Component<HotelStrategyTablesTableDetailLeadtimeSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get columns() {
    const valuePathHotel = COLUMN_PROPERTIES.HOTELINFO;
    const columns = [
      {
        ...COLUMN_CONFIG.HOTELINFO_HEADER,
        subcolumns: [
          {
            ...COLUMN_CONFIG.HOTELINFO,
            name: this.intl.t('general.hotels'),
            tdComponent: HotelStrategyTablesCellsTdStrategyHotel,
            valuePath: valuePathHotel,
          },
        ],
      },
    ];

    const leadtimeColumn = {
      name: this.intl.t('rates.leadtime'),
      thComponent: HotelStrategyTablesCellsThStrategyDetail,
      // @ts-expect-error: Incorrect type
      width: this.args.subtypes.length * COLUMN_WIDTH.DEFAULT,
      hasCompareButton: true,
      subcolumns: [],
    };

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.args.subtypes.forEach((subtype) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathRate = `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`;

      // @ts-expect-error: Incorrect type
      leadtimeColumn.subcolumns.push({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        name: subtype.label,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        columnKey: subtype.label,
        valuePath: valuePathRate,
        tdComponent: HotelStrategyTablesCellsTdStrategyBaserate,
        textAlign: 'center',
        width: COLUMN_WIDTH.DEFAULT,
      });
    });

    // @ts-expect-error: Incorrect type
    columns.push(leadtimeColumn);

    return columns;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rows() {
    // @ts-expect-error: Incorrect type
    const rows = [];

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const leadtimeData = [...this.args.leadtimeDataPerHotelInfo.values()];

    leadtimeData.forEach((rowData) => {
      const row = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        [COLUMN_PROPERTIES.HOTELINFO]: rowData[COLUMN_PROPERTIES.HOTELINFO],
      };

      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.args.subtypes.forEach((subtype) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        row[`${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`] =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rowData[subtype.id][COLUMN_PROPERTIES.RATE];
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        row[`${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.DISCOUNT}`] =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rowData[subtype.id][COLUMN_PROPERTIES.DISCOUNT];
      });

      rows.push(row);
    });

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return rows;
  }

  <template>
    <PrismTable
      {{! @glint-expect-error: Incorrect type }}
      @columns={{this.columns}}
      @enableAutoSortsUpdate={{true}}
      @fillMode="first-column"
      {{! @glint-expect-error: Incorrect type }}
      @initialSorts={{@initialSorts}}
      {{! @glint-expect-error: Incorrect type }}
      @onTableSort={{@onTableSort}}
      @removeTableBorder={{true}}
      @rows={{this.rows}}
      {{! @glint-expect-error: Incorrect type }}
      @sortFunction={{@sortFunction}}
      @widthConstraint="eq-container-slack"
    />
  </template>
}
